import { Loaders } from "../common/store/loaders/loaders.enum";

export const IntegrationCategories = {
  CyberSecurity: 'Cyber Security',
}

export const ManagedBySOCState = {
  Always: 0,
  Optional: 1,
  Never: 2
};

export const ContributionTypeTitles = ["products", "practices", "tools"];

export const ReplaceIntegrationTypes = {
  REMOVE: 0,
  DELETE: 1
}

export const AttestationStatus = {
  ToolsListed: "Tools Listed",
  NoCapability: "No capability",
  NotAnswered: "Not answered",
  IsIncomplete: "TBC",
  Issues: "GovAndRes Listed"
}

export const ComingSoonLabel = "Coming Soon";
export const AllToolsLabel = "All tools";

export const IntegrationState = {
  Syncing: "Syncing"
}

export const ProductsCategoriesTabsData = [{
  id: 0,
  title: 'All',
  key: 'all',
  value: 'All'
},
{
  id: 1,
  title: 'Mapped',
  key: 'mapped',
  value: 'Mapped'
},
{
  id: 2,
  title: 'Not mapped',
  key: 'notMapped',
  value: 'NonMapped'
}]

export const AssetsTabsData = [{
  id: 0,
  title: 'All',
  key: 'all',
},
{
  id: 1,
  title: 'Mapped',
  key: 'mapped',
  value: 'Manually Mapped'
},
{
  id: 2,
  title: 'Not mapped',
  key: 'notMapped',
  value: 'Ignored'
}]

export const MLClientsTabsData = [{
  id: 0,
  title: 'All',
  key: 'all',
  value: 'All'
},
{
  id: 1,
  title: 'Authenticated',
  key: 'mapped',
  value: 'Authenticated'
},
{
  id: 2,
  title: 'Not Authenticated',
  key: 'notMapped',
  value: 'NonAuthenticated'
}]

export const MappingState = {
  HideMapping: 1,
  ViewMapping: 2
}

export const ExceptionsViewData = [
  {
    id: MappingState.HideMapping,
    title: 'Hide Exceptions',
    key: 'hideExceptions',
    value: 'Hide Exceptions',
    apiValue: 1
  },
  {
    id: MappingState.ViewMapping,
    title: 'View Exceptions',
    key: 'viewExceptions',
    value: 'View Exceptions',
    apiValue: 0
  }
]
export const MappingViewData = [
  {
    id: MappingState.HideMapping,
    title: 'Hide Mapping',
    key: 'hideMapping',
    value: 'Hide Mapping',
    apiValue: 1
  },
  {
    id: MappingState.ViewMapping,
    title: 'View Mapping',
    key: 'viewMapping',
    value: 'View Mapping',
    apiValue: 0
  }
]

export const IntegrationStatus = {
  Connected: 'Connected',
  All: 'All'
};

export const IntegrationLoaders = [
  Loaders.GetIntegrationsLoader,
]

export const MicrosoftLighthouseId = process.env.REACT_APP_MICROSOFT_LIGHTHOUSE_ID;